import FormAddCaseStatus, { FormAddCaseStatusData } from 'dashboard/forms/FormAddCaseStatus';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { CaseState } from 'dashboard/models/case-template';

interface AddCaseStatusModalProps {
  handleClose: () => void;
  handleConfirm: (values: FormAddCaseStatusData) => void;
  editMode?: boolean;
  state?: CaseState & { isTheOnlyValidInitialState: boolean };
  allStates: CaseState[];
}

const AddCaseStatusModal = ({
  handleClose,
  handleConfirm,
  allStates,
  editMode = false,
  state,
}: AddCaseStatusModalProps) => (
  <ModalContainer data-test='add-case-status-modal'>
    <ModalHeader data-test='add-case-status-modal__header' onClose={handleClose}>
      {editMode ? 'Edit Status' : 'Add Status'}
    </ModalHeader>

    <ModalBody>
      <FormAddCaseStatus
        onSubmit={handleConfirm}
        onClose={handleClose}
        allStates={
          editMode
            ? /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
              allStates.filter((caseState: CaseState) => caseState.token !== state.token)
            : allStates
        }
        initialValues={editMode ? state : {}}
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        isTheOnlyValidInitialState={editMode ? state.isTheOnlyValidInitialState : false}
      />
    </ModalBody>
  </ModalContainer>
);

export default AddCaseStatusModal;
